export default "__VITE_ASSET__46765c69__"